jQuery($ => {
  if ($(".m-purchase-form__button[disabled]")[0]) {
    $('.m-purchase-form .a-select').on('chooseSelectOption', function () {
      $(this).closest('.m-purchase-form').find('.m-purchase-form__button').removeAttr('disabled');
    });
  }
});